import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  belowFoldContent: {
    marginTop: 0,
  },
  evergreenContainer: {
    [theme.breakpoints.down("sm")]: {
      marginTop: 16,
    },
    [theme.breakpoints.up("md")]: {
      marginTop: 50,
    },
    marginBottom: 88,
    scrollBehavior: "smooth",
  },
  blueBackground: {
    backgroundColor: theme.palette.secondary.light,
    position: "absolute",
    zIndex: -1,
    height: 760,
    width: "100%",
    top: 64,
    left: 0,
    [theme.breakpoints.down("md")]: {
      height: 710,
    },
    [theme.breakpoints.down("sm")]: {
      height: 475,
    },
  },
  infoSection: {
    [theme.breakpoints.up("md")]: {
      paddingTop: 41,
      paddingBottom: 40,
    },
    [theme.breakpoints.down("sm")]: {
      paddingTop: 30,
      paddingBottom: 30,
    },
  },
  imageCarouselContainer: {
    marginBottom: 75,
  },
  mainImage: {
    width: "100%",
    height: "100%",
    maxHeight: 558,
    objectFit: "cover",
    borderRadius: theme.shape.borderRadiusMain,
  },
  imageGalleryContainer: {
    marginBottom: 84,
    display: "flex",
  },
  mainImageContainer: {
    flexGrow: 7,
    maxHeight: 600,
    margin: "0 10px",
    minHeight: 200,
    position: "relative",
    overflow: "hidden",
    [theme.breakpoints.down("md")]: {
      height: 558,
    },
    [theme.breakpoints.down("sm")]: {
      height: 280,
    },
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  gridRootOverride: {
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  evergreenOuterGrid: {
    marginTop: 50,
    marginBottom: 88,
  },
  vehicleVideosTitle: {
    marginBottom: 30,
    fontSize: 36,
    lineHeight: 1.22,
    fontWeight: 500,
  },
}));
